'use strict';

(function () {
    const triggerClassName = 'event-tooltip-trigger'

    const tooltipClassName = 'event-tooltip'

    const visibleClassName = 'event-tooltip--visible'

    const offsetY = 10

    function setCssVar(name, val, el) {
      return name
          && (el || document.documentElement).style
            .setProperty(name, val || '')
    }

    const initEventTooltip = (trigger) => {
        if (!trigger)
            return

        const tooltipId = trigger.getAttribute('aria-describedby')

        const tooltip = tooltipId
            && document.getElementById(tooltipId)

        if (!tooltip)
            return

        const closeBtn = tooltip.querySelector('.event-tooltip__close')

        const positionTooltip = () => {
            const rect = trigger.getBoundingClientRect();

            setCssVar('--tooltip-left', `${rect.left}px`, tooltip)

            tooltip.style.left = `${rect.left}px`;
            tooltip.style.top = `${rect.bottom + offsetY}px`;
        };

        const open = () => {
            positionTooltip()

            tooltip.classList.add(visibleClassName)

            tooltip.setAttribute('aria-hidden', 'false')
        }

        const close = () => {
            tooltip.classList.remove(visibleClassName)

            tooltip.setAttribute('aria-hidden', 'true')
        }

        const toggle = () => {
            if (tooltip.classList.contains(visibleClassName))
                close()
            else
                open()
        }

        trigger.addEventListener('click', (e) => {
            e.preventDefault()

            toggle()
        })

        trigger.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === 'Escape') {
                e.preventDefault()

                toggle()
            }
        })

        if (closeBtn) {
            closeBtn.addEventListener('click', (e) => {
                e.stopPropagation()

                close()
            })
        }

        document.addEventListener('click', (e) => {
            if (!tooltip.classList.contains(visibleClassName))
                return

            if (trigger.contains(e.target)
                    || tooltip.contains(e.target))
                return

            close()
        })

        const onReposition = () => {
            if (tooltip.classList.contains(visibleClassName))
                positionTooltip()
        }

        window.addEventListener('resize', onReposition)

        window.addEventListener('scroll', onReposition, { passive: true })
    }

    window.addEventListener('load', () => {
        const triggers = document.querySelectorAll(`.${triggerClassName}`)

        if (!triggers.length)
            return

        triggers.forEach(initEventTooltip)
    })
})()
